import { FadeUp } from "@/components/Reveal";

const IMG = "/images/editorial-desk.webp";

export default function Editorial() {
  return (
    <section className="relative py-24 sm:py-32" data-testid="editorial-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-32">
              <FadeUp>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-neon mb-5 flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-neon inline-block pulse-dot" />
                  Why Jiggly exists
                </p>
              </FadeUp>
              <FadeUp delay={0.08}>
                <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.08]">
                  The ultimate online status keeper
                </h2>
              </FadeUp>
              <FadeUp delay={0.16}>
                <p className="mt-6 text-mist leading-relaxed">
                  In today's remote work environment, maintaining an active status on communication platforms is
                  crucial. Your computer's sleep mode can instantly flag you as <em className="text-white not-italic font-medium">'Away'</em>.
                </p>
              </FadeUp>
            </div>
          </div>

          <div className="lg:col-span-7">
            <FadeUp delay={0.1}>
              <p className="text-lg text-white/90 leading-relaxed first-letter:font-display first-letter:text-neon first-letter:text-6xl first-letter:font-black first-letter:float-left first-letter:mr-4 first-letter:leading-[0.85]">
                Jiggly is the premier online mouse jiggler designed to solve this exact problem without requiring
                any hardware or software installations. No download, no extension, no admin prompt — the entire
                engine lives on a web page.
              </p>
            </FadeUp>
            <FadeUp delay={0.18}>
              <p className="mt-7 text-mist leading-relaxed">
                By leveraging native browser APIs, our web-based mouse mover simulates active user engagement. A
                silent audio loop prevents your browser from throttling the tab, the Wake Lock API requests a
                continuous wake state from your operating system, and synthetic pointer events keep web apps
                convinced that someone is right there — focused, present, online.
              </p>
            </FadeUp>
            <FadeUp delay={0.26}>
              <p className="mt-7 text-mist leading-relaxed">
                This prevents your screensaver from activating and ensures your computer remains awake, so your dot
                stays green on Teams, Slack, Zoom and every platform in between.
              </p>
            </FadeUp>

            <FadeUp delay={0.3}>
              <div className="relative mt-12 rounded-2xl overflow-hidden border border-white/10 group">
                <img
                  src={IMG}
                  alt="A dark home-office desk setup glowing at night"
                  className="w-full h-64 sm:h-80 object-cover"
                  loading="lazy"
                  decoding="async"
                  width="480"
                  height="720"
                  data-testid="editorial-image"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent pointer-events-none" />
                <div className="absolute bottom-5 left-5 flex items-center gap-3">
                  <span className="w-2 h-2 rounded-full bg-neon pulse-dot" />
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/80">
                    Engineered for the quietly online
                  </span>
                </div>
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
